export default __webpack_public_path__ + "static/berlin-7ecf408bf9b7f103ab7a0631d578d123.jpg";